import { Modal } from "../modal";

export const ConfirmDelete = ({
  open,
  closeModal,
  onCancel,
  onConfirm,
  loading = false,
  title = "Are you sure?",
  children,
  okText = "Delete",
  okButtonProps = {},
}) => {
  const handleCancel = closeModal || onCancel;

  const handleOk = async () => {
    try {
      await onConfirm();
      handleCancel();
    } catch (err) {
      // Re-throw error so caller can handle it (e.g., show error message in modal)
      throw err;
    }
  };

  return (
    <Modal
      open={open}
      onCancel={handleCancel}
      title={title}
      onOk={handleOk}
      okText={okText}
      okButtonProps={{ loading, danger: true, ...okButtonProps }}
    >
      {children}
    </Modal>
  );
};
